import GlobalAnalytic from "./GlobalAnalytic";

export default GlobalAnalytic;
